module.exports = __webpack_public_path__ + "static/inventory-3a794085deba82787eed1e1d5d3d7f36.jpg";